// lib
import { useRef } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'

import countText from '@aytm/app/survey/editor/lib/text-count'

// components
import RichTextCounter from '@aytm/lib/rfd-ui/components/advanced/rich-text-counter'

// styles
import style from '@aytm/app/stats/components/text-editor/TextEditor.module.scss'

export const formatOptions = Map({
  BOLD: true,
  ITALIC: true,
  UNDERLINE: true,
  blockquote: true,
  'header-one': true
})

const TextEditor = ({ text, height = 230, characters = 250, className, disabled, decorators, onChange }) => {
  const refEditorField = useRef()

  const onFocus = () => {
    refEditorField.current.refRichText.refEditor.focus()
  }

  const onTextChange = getContent => {
    const { html } = getContent({ html: true, text: false })
    'function' == typeof onChange && onChange(html)
  }

  return (
    <div className={style.component}>
      {!disabled ? (
        <div className={className ? ` ${className}` : ''} onClick={onFocus}>
          <RichTextCounter
            ref={refEditorField}
            readOnly={false}
            placeholder="Start typing..."
            characters={characters}
            trimAt={0}
            allowUndo
            countText={countText}
            html={text}
            minHeight={height}
            multiline
            formatOptions={formatOptions}
            decorators={decorators}
            onChange={onTextChange}
          />
        </div>
      ) : (
        <div className={style.text} dangerouslySetInnerHTML={{ __html: text }} />
      )}
    </div>
  )
}

TextEditor.propTypes = {
  text: PropTypes.string,
  height: PropTypes.number,
  characters: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  decorators: PropTypes.array,
  onChange: PropTypes.func.isRequired
}

TextEditor.displayName = 'TextEditor'

export default TextEditor
